// extracted by mini-css-extract-plugin
module.exports = {"CampingPower":"CampingPower_CampingPower__kOzjP"};